import React from "react";
// eslint-disable-next-line import/no-unresolved
import buildConfig from "@regional/config/build.config.json";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

const {
  copyrightText,
  footerLegalItems,
  footerLink,
  footerLinkTitle,
  footerLogoLink,
} = buildConfig;
const year = new Date().getFullYear();
const footerLinks = {
  accessibility: (
    <Typography
      component={Link}
      href="/accessibility"
      target="_blank"
      rel="noopener noreferrer"
    >
      Accessibility
    </Typography>
  ),
  privacyPolicy: (
    <Typography
      component={Link}
      href="/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
    >
      Privacy Policy
    </Typography>
  ),
  termsConditions: (
    <Typography
      component={Link}
      href="/terms-conditions"
      target="_blank"
      rel="noopener noreferrer"
    >
      Terms and Conditions
    </Typography>
  ),
  faq: (
    <Typography
      component={Link}
      href="/faq"
      target="_blank"
      rel="noopener noreferrer"
    >
      FAQ
    </Typography>
  ),
};

function Separator() {
  return (
    <Typography component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
      |
    </Typography>
  );
}

export function FooterLinksLeft() {
  return (
    <>
      <Typography style={{ marginRight: "0.625rem" }}>
        © {year} {copyrightText}
      </Typography>
      {footerLegalItems &&
        footerLegalItems.length > 0 &&
        footerLegalItems.map((item) =>
          footerLinks[item] ? (
            <React.Fragment key={item}>
              <Separator />
              {footerLinks[item]}
            </React.Fragment>
          ) : null
        )}
    </>
  );
}

export function FooterLinksRight() {
  return (
    <>
      <Typography
        component={Link}
        target="_blank"
        href={
          footerLogoLink ||
          "https://www.tylertech.com/solutions/public-administration/regulatory/cannabis-licensing"
        }
        rel="noopener noreferrer"
        aria-label="Tyler Technologies"
      >
        <img
          src="/dist/images/brand/nic/tylerTechLogoSmall.png"
          height="40px"
          alt="tylerTech logo"
        />
      </Typography>
      <Separator />
      <Typography
        component={Link}
        href={footerLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{ marginRight: "0.625rem" }}
      >
        {footerLinkTitle}
      </Typography>
      <Separator />
      <Typography style={{ marginLeft: "0.625rem" }}>
        v.{process.env.REACT_APP_VERSION}
      </Typography>
    </>
  );
}
